import React, { useState, useEffect } from "react";
import classes from "./ProductsPage.module.css";
import Modal from "../../components/UI/Modal/Modal";
import { useForm, SubmitHandler, useFieldArray, Controller } from "react-hook-form";
import { getEquipments } from "../../api/equipmentAPI";
import { EquipmentData } from "../../types/api/equipment";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import {
    Stack,
    Box,
    Button,
    InputAdornment,
    OutlinedInput,
    TextField,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    SelectChangeEvent,
    Pagination,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { createNewProduct, getProductsList, deleteProduct, getProductById, editProduct } from "../../api/productAPI";
import { ProductData, ProductDataCreate, ProductDataEdit } from "../../types/api/products";
import Loader from "../../components/Loader/Loader";
import { useNotification } from "../../hooks/useNotification";
import CustomSnackbar from "../../components/UI/CustomSnackbar";
import PhotoUpload from "../../components/PhotoUpload/PhotoUpload";
import Search from "../../components/Search/Search";
import { BASE, BASE_IMG_URL } from "../../constants/mainAPI";
import QRCode from "react-qr-code";
import { MoneyField } from "../../components/UI/MoneyField/MoneyField";
import { AsynchronousEquipment } from "../../components/Autocomplete/Asynchronous/AsynchronousEquipment";

const ProductsPage = (props: any) => {
    const location = useLocation();
    const [params] = useSearchParams();
    const queryProductId = params.get("productId");
    var pageSettings = {
        Header: "",
        bottomAddButtonText: "",
    };

    if (props.productType === 0) {
        pageSettings.Header = "Прототипы";
        pageSettings.bottomAddButtonText = "Добавить прототип";
    } else {
        pageSettings.Header = "Дополнительные услуги";
        pageSettings.bottomAddButtonText = "Добавить услугу";
    }

    const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showOrderModal, setShowOrderModal] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);

    const [numberOfDeletingProto, setNumberOfDeletingProto] = useState<any>("");

    const [list, setList] = useState<Array<ProductData>>();
    const [currentProduct, setCurentProduct] = useState<ProductData>();
    const [orderAmount, setOrderAmount] = useState<number>(1);

    const [loading, setLoading] = useState(true);
    const [isAdmin, setAdminFlag] = useState(false);

    const { id } = useParams();
    const [productId, setProductId] = useState();
    const [equipments, setEquipments] = useState<Array<EquipmentData>>();

    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
    });

    const [query, setQuery] = useState("");

    const { setNotification, setOpenSnackbar, notification, openSnackbar } = useNotification();

    const fetchProductsList = (query?: string) => {
        setLoading(true);
        getProductsList(
            id,
            ({ data, last_page, current_page }) => {
                setList(data);
                setLoading(false);
                setPagination({ ...pagination, last_page: last_page, current_page: current_page });
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoading(false);
            },
            query
                ? { page: pagination.current_page, q: query, type: props.productType }
                : { page: pagination.current_page, type: props.productType },
        );
    };

    const closeCreateModal = () => {
        setShowCreateModal(false);
    };

    const closeOrderModal = () => {
        setShowOrderModal(false);
        setCurentProduct(undefined);
        setOrderAmount(0);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setNumberOfDeletingProto("");
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setCurentProduct(undefined);
    };

    const createForm = useForm<ProductDataCreate>({
        defaultValues: {
            type: props.productType,
        },
    });

    const equipmentCreateArray = useFieldArray({
        control: createForm.control,
        name: "equipment",
    });

    const editForm = useForm<ProductDataEdit>();

    const equipmentEditeArray = useFieldArray({
        control: editForm.control,
        name: "equipment",
    });

    const onSubmit: SubmitHandler<ProductDataCreate> = (data: any) => {
        data.type = props.productType;
        setLoading(true);
        createNewProduct(
            { ...data, cost: data.cost ? data.cost * 100 : 0 },
            () => {
                fetchProductsList(query);
                setNotification({
                    severity: "success",
                    message: "Успешно добавлено",
                });
                setOpenSnackbar(true);
                closeCreateModal();
                setLoading(false);
                createForm.reset();
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setOpenSnackbar(true);
                setLoading(false);
                Object.keys(err.errors).forEach((fieldName: any) => {
                    createForm.setError(fieldName, {
                        type: "custom",
                        message: err.errors[fieldName][0],
                    });
                });
            },
        );
    };

    const onEdit: SubmitHandler<ProductDataCreate> = (data: any) => {
        data.type = props.productType;
        setLoading(true);
        editProduct(
            productId,
            { ...data, cost: data.cost ? data.cost * 100 : 0 },
            () => {
                fetchProductsList(query);
                setNotification({
                    severity: "success",
                    message: "Успешно изменено",
                });
                setOpenSnackbar(true);
                closeEditModal();
                setLoading(false);
                editForm.reset();
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoading(false);
                setOpenSnackbar(true);
                Object.keys(err.errors).forEach((fieldName: any) => {
                    editForm.setError(fieldName, {
                        type: "custom",
                        message: err.errors[fieldName][0],
                    });
                });
            },
        );
    };

    const delProto = (productId: any) => {
        deleteProduct(
            productId,
            () => {
                fetchProductsList(query);
                setNotification({
                    severity: "success",
                    message: "Успешно удалено",
                });
                setOpenSnackbar(true);
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setOpenSnackbar(true);
                setLoading(false);
            },
        );
        closeDeleteModal();
    };

    const openOrderModal = (id: any) => {
        setCurentProduct(list?.filter(el => el.id == id)[0]);
        setShowOrderModal(true);
    };

    const sendOrder = () => {};

    const setOrderAmountInput = (e: any) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setOrderAmount(e.target.value);
        }
    };

    const editProtoBtnClick = (id: any) => {
        setProductId(id);
        editForm.reset();
        getProductById(id, currentProto => {
            editForm.reset({ ...currentProto.data, cost: currentProto.data.cost / 100 });
            editForm.setValue(
                "equipment",
                currentProto?.data?.equipment?.map(function (equipment: any) {
                    return equipment.id;
                }),
            );
            currentProto?.data?.equipment?.forEach(function (equipment: any, index: number) {
                editForm.setValue(`delete_equipment.${index}`, equipment.id);
            });
            setCurentProduct(currentProto.data);
            setShowEditModal(true);
        });
    };

    const addEqupmentInput = () => {
        equipmentCreateArray.append("");
    };

    const deleteEqupmentInput = (index: number) => {
        if (equipmentCreateArray.fields.length == 1) {
            return;
        }
        equipmentCreateArray.remove(index);
    };

    const addEditEqupmentInput = (e: any) => {
        equipmentEditeArray.append("");
    };

    const deleteEditEqupmentInput = (index: number) => {
        if (equipmentEditeArray.fields.length == 1) {
            return;
        }
        equipmentEditeArray.remove(index);
    };

    const addProductBtnClick = () => {
        setShowCreateModal(true);
        addEqupmentInput();
    };

    useEffect(() => {
        setLoading(true);
        fetchProductsList(query);
    }, [pagination.current_page, query]);

    useEffect(() => {
        fetchProductsList(query);
        getEquipments(
            id,
            ({ data }) => {
                setEquipments(data);
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoading(false);
            },
            { per_page: -1 },
        );
        if (
            localStorage.getItem("employee_type") == "16" &&
            localStorage.getItem("employee_center_id") == localStorage.getItem("current_center_id")
        ) {
            setAdminFlag(true);
        } else {
            setAdminFlag(false);
        }
    }, []);

    useEffect(() => {
        if (queryProductId && list?.length) {
            setCurentProduct(list?.filter(el => el.id === Number(queryProductId))[0]);

            setTimeout(() => {
                setShowOrderModal(true);
            }, 10);
        }
    }, [queryProductId, list]);

    return (
        <>
            <div className={"container"}>
                <div className="pageHeader">{pageSettings.Header}</div>
                <Search
                    clearHandler={value => {
                        setQuery(value);
                    }}
                    searchHandler={value => {
                        setQuery(value);
                    }}
                />
                <TableContainer component={Paper} sx={{ marginBottom: "80px" }}>
                    <Table
                        aria-label="centers table"
                        sx={{
                            "& td": { border: "none" },
                            "& img": {
                                objectFit: "cover",
                                maxHeight: "320px",
                                width: "160px",
                            },
                        }}>
                        <TableHead
                            sx={{
                                "& th": { fontSize: "16px", fontWeight: 700 },
                            }}>
                            <TableRow>
                                <TableCell>Наименование</TableCell>
                                <TableCell align="center">Фото</TableCell>
                                <TableCell align="center">Описание</TableCell>
                                <TableCell align="center">Закупочная стоимость</TableCell>
                                <TableCell align="center">QR код</TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list?.map(product => (
                                <TableRow key={product.id} sx={{ border: 0 }}>
                                    <TableCell align="center">{product.name}</TableCell>
                                    <TableCell align="center">
                                        <img
                                            alt={product.photos[0].name}
                                            key={product.photos[0].id}
                                            className={classes.product__photo}
                                            src={`${BASE_IMG_URL}/${product.photos[0].path}`}
                                        />
                                    </TableCell>
                                    <TableCell align="center">{product.description}</TableCell>
                                    <TableCell align="center">{product.cost / 100} &#8381;</TableCell>
                                    <TableCell
                                        sx={{
                                            heigth: "80px",
                                            width: "80px",
                                        }}>
                                        <QRCode
                                            size={140}
                                            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                            value={`${BASE}/#${location.pathname}?productId=${product.id}`}
                                            viewBox={`0 0 140 140`}
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        {isAdmin ? (
                                            <div className={"btnContainer"}>
                                                <Button
                                                    variant="outlined"
                                                    fullWidth
                                                    onClick={() => editProtoBtnClick(product.id)}>
                                                    Изменить
                                                </Button>
                                                <Button
                                                    variant="outlined"
                                                    fullWidth
                                                    onClick={() => {
                                                        setShowDeleteModal(true);
                                                        setNumberOfDeletingProto(product.id);
                                                    }}>
                                                    Удалить
                                                </Button>
                                            </div>
                                        ) : (
                                            <Button variant="outlined" onClick={() => openOrderModal(product.id)}>
                                                Заказать
                                            </Button>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={"posBR"}>
                    <div className={"paginationContainer"}>
                        <Pagination
                            onChange={(index, qwerty) => setPagination({ ...pagination, current_page: qwerty })}
                            page={pagination.current_page}
                            count={pagination.last_page}
                            shape="rounded"
                        />
                    </div>
                    {isAdmin && (
                        <Button variant="outlined" onClick={() => addProductBtnClick()}>
                            {pageSettings.bottomAddButtonText}
                        </Button>
                    )}
                </div>
            </div>
            <Modal
                open={showCreateModal}
                title={"Добавление"}
                onClose={closeCreateModal}
                onSubmit={createForm.handleSubmit(onSubmit)}>
                <Box
                    component="form"
                    sx={{
                        "& .MuiTextField-root": { my: 1 },
                    }}
                    noValidate
                    autoComplete="off">
                    <div>
                        <Controller
                            defaultValue={""}
                            name="name"
                            control={createForm.control}
                            rules={{
                                required: true,
                                maxLength: {
                                    value: 120,
                                    message: "Максимальная длина 120 символов",
                                },
                            }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    size={"small"}
                                    fullWidth
                                    label={"Наименование"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </div>
                    <div>
                        <Controller
                            defaultValue={""}
                            name="description"
                            control={createForm.control}
                            rules={{
                                required: true,
                                maxLength: {
                                    value: 1000,
                                    message: "Максимальная длина 1000 символов",
                                },
                            }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    size={"small"}
                                    fullWidth
                                    label={"Описание до 1000 символов"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </div>
                    <MoneyField name="cost" control={createForm.control} label={"Закупочная стоимость"} />
                    <div>
                        <Controller
                            defaultValue={""}
                            name="photos"
                            control={createForm.control}
                            rules={{ required: true }}
                            render={({ field: { value }, fieldState, formState: { errors } }) => {
                                return (
                                    <PhotoUpload
                                        formError={errors?.photos?.type === "required"}
                                        error={fieldState.error}
                                        field={{ photos: value }}
                                        setValue={createForm.setValue}
                                    />
                                );
                            }}
                        />
                    </div>
                    <div>
                        <InputLabel sx={{ padding: "10px", textAlign: "left" }}>Используемое оборудование</InputLabel>
                        {equipmentCreateArray?.fields.map((field: any, index: number) => (
                            <div>
                                <Controller
                                    defaultValue={""}
                                    name={`equipment.${index}`}
                                    control={createForm.control}
                                    rules={{ required: true }}
                                    key={field.id}
                                    render={({ field: { onChange, value }, fieldState }) => (
                                        <FormControl sx={{ width: "100%" }}>
                                            <Stack
                                                direction="row"
                                                spacing={3}
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                sx={{ p: 0.5 }}>
                                                {/* <Select
                                                    size={"small"}
                                                    fullWidth
                                                    className={classes.select_width}
                                                    labelId={`equipment.${index}`}
                                                    onChange={(event: SelectChangeEvent) => {
                                                        onChange(event.target.value);
                                                    }}
                                                    value={value?.toString()}
                                                    autoComplete="off"
                                                    error={!!fieldState.error}>
                                                    {equipments?.map((item: any) => (
                                                        <MenuItem value={item.id} key={item.id} id={item.id}>
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select> */}
                                                <AsynchronousEquipment
                                                    onChange={item => {
                                                        onChange(item.id);
                                                    }}
                                                    options={equipments ?? []}
                                                />
                                                <Button
                                                    variant="outlined"
                                                    type="button"
                                                    onClick={() => {
                                                        deleteEqupmentInput(index);
                                                    }}>
                                                    удалить
                                                </Button>
                                            </Stack>
                                            {/* <FormHelperText>{fieldState.error?.message}</FormHelperText> */}
                                        </FormControl>
                                    )}
                                />
                            </div>
                        ))}
                    </div>
                    <div className={classes.form__addBtn} onClick={addEqupmentInput}>
                        + ЕЩЕ
                    </div>
                </Box>
            </Modal>
            <Modal
                open={showDeleteModal}
                title={"Удаление"}
                onClose={closeDeleteModal}
                onSubmit={() => delProto(numberOfDeletingProto)}>
                <div>Вы уверены, что хотите удалить?</div>
            </Modal>
            <Modal open={showOrderModal} title={"Заказать"} onClose={closeOrderModal} onSubmit={() => sendOrder()}>
                <div className={classes.orderModal__subtitle}>{currentProduct?.name}</div>
                <div className={`${classes.orderModal} ${classes.orderModal__flex}`} key={currentProduct?.id}>
                    <div className={classes.orderModal__image}>
                        <img
                            alt={currentProduct?.photos[0].name}
                            key={currentProduct?.photos[0].id}
                            className={classes.product__photo}
                            src={`${BASE_IMG_URL}/${currentProduct?.photos[0].path}`}
                        />
                    </div>
                    <div className={classes.orderModal__inputs}>
                        <div className={classes.orderModal__flex}>
                            <div className={classes.orderModal__label}>
                                <InputLabel className={classes.float_left} htmlFor="orderModal__cost">
                                    Цена:
                                </InputLabel>
                            </div>
                            <OutlinedInput
                                className={classes.orderModal__input}
                                id="orderModal__cost"
                                defaultValue={`${currentProduct?.cost}`}
                                disabled
                            />
                            <div className={classes.orderModal__units}>&#8381;</div>
                        </div>
                        <div className={classes.orderModal__flex}>
                            <div className={classes.orderModal__label}>
                                <InputLabel className={classes.float_left} htmlFor="orderModal__amount">
                                    Количество:
                                </InputLabel>
                            </div>
                            <OutlinedInput
                                className={classes.orderModal__input}
                                id="orderModal__amount"
                                value={orderAmount}
                                onChange={e => {
                                    setOrderAmountInput(e);
                                }}
                            />
                            <div className={classes.orderModal__units}>шт.</div>
                        </div>
                        <div className={`${classes.orderModal__flex} ${classes.orderModal__total}`}>
                            <div className={classes.orderModal__label}>
                                <InputLabel className={classes.float_left} htmlFor="orderModal__total">
                                    Итого:
                                </InputLabel>
                            </div>
                            <OutlinedInput
                                className={classes.orderModal__input}
                                id="orderModal__total"
                                disabled
                                value={currentProduct?.cost || 0 * orderAmount}
                            />
                            <div className={classes.orderModal__units}>&#8381;</div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                open={showEditModal}
                title={"Редактирование"}
                onClose={closeEditModal}
                onSubmit={editForm.handleSubmit(onEdit)}>
                <Box component="form" sx={{ "& .MuiTextField-root": { my: 1 } }} noValidate autoComplete="off">
                    <div>
                        <Controller
                            defaultValue={""}
                            name="name"
                            control={editForm.control}
                            rules={{ required: true }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    size={"small"}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    label={"Наименование"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </div>
                    <div>
                        <Controller
                            defaultValue={""}
                            name="description"
                            control={editForm.control}
                            rules={{ required: true }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    size={"small"}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    label={"Описание до 1000 символов"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </div>
                    <MoneyField name="cost" control={editForm.control} label={"Закупочная стоимость"} />
                    <div className={classes.form__image}>
                        <Controller
                            defaultValue={""}
                            name="photos"
                            control={editForm.control}
                            render={({ field: { value }, fieldState }) => {
                                return (
                                    <PhotoUpload
                                        error={fieldState.error}
                                        field={{ photos: value }}
                                        setValue={editForm.setValue}
                                    />
                                );
                            }}
                        />
                    </div>
                    <div>
                        <InputLabel sx={{ padding: "10px", textAlign: "left" }}>Используемое оборудование</InputLabel>
                        {equipmentEditeArray?.fields.map((field: any, index: number) => (
                            <div>
                                <Controller
                                    defaultValue={""}
                                    name={`equipment.${index}`}
                                    control={editForm.control}
                                    rules={{ required: true }}
                                    key={field.id}
                                    render={({ field: { onChange, value }, fieldState }) => (
                                        <FormControl sx={{ width: "100%" }}>
                                            <Stack
                                                direction="row"
                                                spacing={3}
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                sx={{ p: 0.5 }}>
                                                {/* <Select
                                                    size={"small"}
                                                    fullWidth
                                                    className={classes.select_width}
                                                    labelId={`equipment.${index}`}
                                                    onChange={(event: SelectChangeEvent) => {
                                                        onChange(event.target.value);
                                                    }}
                                                    value={value.toString()}
                                                    autoComplete="off"
                                                    error={!!fieldState.error}>
                                                    {equipments?.map((item: any) => (
                                                        <MenuItem value={item.id} key={item.id} id={item.id}>
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select> */}
                                                <AsynchronousEquipment
                                                    onChange={item => {
                                                        onChange(item.id);
                                                    }}
                                                    options={equipments ?? []}
                                                    value={value}
                                                />
                                                <Button
                                                    variant="outlined"
                                                    type="button"
                                                    onClick={() => {
                                                        deleteEditEqupmentInput(index);
                                                    }}>
                                                    удалить
                                                </Button>
                                            </Stack>

                                            {/* <FormHelperText>{fieldState.error?.message}</FormHelperText> */}
                                        </FormControl>
                                    )}
                                />
                            </div>
                        ))}
                    </div>
                    <div className={classes.form__addBtn} onClick={addEditEqupmentInput}>
                        + ЕЩЕ
                    </div>
                </Box>
            </Modal>
            <CustomSnackbar openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} notification={notification} />
            <Loader backDrop open={loading} />
        </>
    );
};

export default ProductsPage;
